import '../../polyfills/request_video_frame_callback.js';

import type { ContentType } from '../../types.js';
import type { CompareAwarePlayerOptions } from '../compare_aware_player/compare_aware_player';
import { BaseVideoPlayer } from './base_video_player.js';

export class VideoPlayer extends BaseVideoPlayer {
  playerType: ContentType = 'video';

  constructor(options: CompareAwarePlayerOptions) {
    super(options);
    this.mediaElement = document.createElement('video');
    this.initMediaElement();
  }
}
